import React, { useState, useEffect } from 'react';
import { useParams, useOutletContext } from 'react-router-dom';
import PostCard from '../../../components/Portal/PostCard';
import { portalTournamentAPI } from '../../../services/api';

/**
 * PortalActivityTab - News reel of TD-posted activity updates.
 * Pinned posts stick to top, then sorted newest first.
 */
const PortalActivityTab = () => {
  const { tournamentId } = useParams();
  const { tournament } = useOutletContext();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const res = await portalTournamentAPI.getActivity(tournamentId);
        setPosts(res.data?.data?.posts || []);
      } catch (err) {
        console.error('Failed to load activity:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, [tournamentId]);

  if (loading) {
    return (
      <div className="flex justify-center py-8">
        <div className="animate-spin h-6 w-6 border-4 border-green-500 border-t-transparent rounded-full" />
      </div>
    );
  }

  if (posts.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="text-3xl mb-2">&#128227;</div>
        <h3 className="font-medium text-gray-700 mb-1">No Updates Yet</h3>
        <p className="text-sm text-gray-500">
          Your tournament director will post updates here.
        </p>
      </div>
    );
  }

  // Pinned first, then by date desc
  const sorted = [...posts].sort((a, b) => {
    if (a.pinned && !b.pinned) return -1;
    if (!a.pinned && b.pinned) return 1;
    return new Date(b.publishedAt || b.createdAt) - new Date(a.publishedAt || a.createdAt);
  });

  return (
    <div className="space-y-3">
      {sorted.map((post) => (
        <PostCard key={post._id} post={post} />
      ))}
    </div>
  );
};

export default PortalActivityTab;
